<script>
    export let value;
    export let label;
    export let name;
    export let cols=30;
    export let rows=5;
    export let maxlength;
</script>

<label>
    {#if label}
        <div class="label-container">
            <span class="label">
                {label}
            </span>
            {#if maxlength}
                <span class="maxlength" class:full={value?.length >= maxlength}>
                    {value?.length??0} / {maxlength} Zeichen
                </span>
            {/if}
        </div>
    {/if}
    <textarea {name} bind:value={value} {maxlength} {cols} {rows} resize={false}></textarea>
</label>

<style>
    label {
        margin-bottom: 1rem;
    }

    .label-container {
        display: flex;
        justify-content: space-between;
        font-size: 0.8rem;
        margin-bottom: 0.2rem;
    }

    .label {
        flex: 1;
        display: inline-block;
    }

    .maxlength {
        text-align: right;
        display: inline-block;
        width: 17ch;
    }

    .full {
        color: red;
    }

    textarea {
        display: block;
        border-radius: 0.5rem;
        border: 2px solid #F5F2EF;
        width: 100%;
        resize: none;
    }
</style>